export default __webpack_public_path__ + "static/icon-aeb8450750909a0923e09e64010b6e8a.png";